module.exports = __webpack_public_path__ + "img/waistline back pocket position.bc9c0637.png";